var React = require('react');

function TickRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 3L11 8L6 13","strokeWidth":"2"}));
}

TickRightInline.defaultProps = {"width":"1.6rem","height":"1.6rem","viewBox":"0 0 16 16","fill":"none","preserveAspectRatio":"xMidYMid"};

module.exports = TickRightInline;

TickRightInline.default = TickRightInline;
